const AppIdMap = Object.freeze({
    'bot.binary.com': '37985',
    'bot.binary.me' : '37985',
    'binary.bot'    : '37985',
});
export default AppIdMap;



// WEBPACK FOOTER //
// ./src/common/appIdResolver.js